import { IonicPage } from 'ionic-angular';
import { Component } from '@angular/core';
import { AppConfig } from '../../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-daily-observation-edit',
  templateUrl: 'daily-observation-edit.html',
})
export class DailyObservationEditPage {
  config = AppConfig.settings;

  constructor() {
  }

  ionViewDidLoad() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/DPR Pages/daily-observations/daily-observations/daily-observation-edit.ts